import {
    CHANGE_NOTIFICATIONS_CASE_TYPE_FILTER,
    CHANGE_NOTIFICATIONS_FIELD, CHANGE_NOTIFICATIONS_STATUS_FILTER,
    CLEAR_ERROR_NOTIFICATIONS, GET_NOTIFICATION_TYPES_FAILED, GET_NOTIFICATION_TYPES_SUCCESS,
    LOGOUT, NOTIFICATIONS_PAGE_SHIFT, RECEIVE_BAD_REQUEST_GET_ALL_NOTIFICATIONS,
    RECEIVE_FAILURE_GET_NOTIFICATIONS_INDICATOR,
    RECEIVE_GET_ALL_NOTIFICATIONS, RECEIVE_GET_NOTIFICATIONS_INDICATOR, REQUEST_GET_ALL_NOTIFICATIONS,
    REQUEST_GET_NOTIFICATIONS_INDICATOR
} from "../actions/index";
import {CLEAR_NOTIFICATIONS_FILTERS, GET_NOTIFICATION_TYPES, RECEIVE_LOG_IN_RESPONSE} from "../actions";
import {isAragUser} from "../helpers/functions";

const defaultState = {
	notifications: [],
	allNotifications: [],
	fetching: false,
	errMsg: '',
	selectedView: '20',
	page: 1,
	totalBoxes: 1,
	value: '',
	selectedNotification: {},
	selectedStatus: '',
	selectedCaseType: '',
	notificationsIconCount: 0,
	notificationsIconFailureMsg: "",
	notificationsIconFetching: false,
	selectedUpdateFormQuestions: [],
	selectedNotificationTypes: [],
	selectedStatuses: [],
	selectedCaseTypes: [],
	wasFilterButtonPressed: false,
    fetchingNotificationTypes: false,
    notificationTypes: []
};

export default (state = defaultState, action) => {
	switch (action.type) {
		case RECEIVE_LOG_IN_RESPONSE:
			if (isAragUser(action.payload.body.roles)){
				return {
					...state,
					selectedCaseTypes: action.payload.body.selectedCaseTypes
						.map(item=> ({value: item, label: '', machineName: item})),
					selectedNotificationTypes: action.payload.body.selectedNotificationTypes
						.map(item=> ({value: item, label: '', machineName: item})),
					selectedStatuses: action.payload.body.selectedStatuses
						.map(item=> ({value: item, label: '', machineName: item})),
					selectedUpdateFormQuestions: action.payload.body.selectedUpdateQuestions
						.map(item=> ({value: item, label: '', machineName: item})),
				};
			}

			return {
				...state
			};
        case GET_NOTIFICATION_TYPES:
            return {
                ...state,
                fetchingNotificationTypes: true
            };
        case GET_NOTIFICATION_TYPES_SUCCESS:
            return {
                ...state,
                fetchingNotificationTypes: false,
                notificationTypes: action.payload.body
            };
        case GET_NOTIFICATION_TYPES_FAILED:
            return {
                ...state,
                fetchingNotificationTypes: false
            };
		case CLEAR_NOTIFICATIONS_FILTERS:
			return {
				...state,
				wasFilterButtonPressed: false,
				selectedUpdateFormQuestions: defaultState.selectedUpdateFormQuestions,
				selectedStatuses: defaultState.selectedStatuses,
				selectedCaseTypes: defaultState.selectedCaseTypes,
				selectedNotificationTypes: defaultState.selectedNotificationTypes
			};
		case 'persist/REHYDRATE':
			return {
				...state,
				...(action.payload?action.payload.notifications:defaultState),
				errMsg: defaultState.errMsg
			};
		case REQUEST_GET_NOTIFICATIONS_INDICATOR:
			return {
				...state,
				notificationsIconFetching: true
			};
		case RECEIVE_GET_NOTIFICATIONS_INDICATOR:
			return {
				...state,
				notificationsIconFetching: false,
				notificationsIconCount: action.payload
			};
		case RECEIVE_FAILURE_GET_NOTIFICATIONS_INDICATOR:
			return {
				...state,
				notificationsIconFetching: false,
				notificationsIconFailureMsg: action.payload
			};
		case REQUEST_GET_ALL_NOTIFICATIONS:
			return {
				...state,
				fetching: true,
				errMsg: ''
			};
		case RECEIVE_GET_ALL_NOTIFICATIONS:
			let totalDisplayBoxes = Math.ceil(action.payload.totalRecords / parseInt(state.selectedView));
			let currentPage = parseInt(state.page);
			if(currentPage > totalDisplayBoxes && totalDisplayBoxes !== 0){
				currentPage = totalDisplayBoxes;
			}
			return {
				...state,
				fetching: false,
				notifications: action.payload.data,
				allNotifications: action.payload.data,
				totalBoxes: totalDisplayBoxes,
				errMsg: '',
				totalRecords: action.payload.totalRecords,
				page: currentPage
			};
		case RECEIVE_BAD_REQUEST_GET_ALL_NOTIFICATIONS:
			return {
				...state,
				errMsg: 'Failed To receive notifications. Please try again later.',
                fetching: false
            };
		case CLEAR_ERROR_NOTIFICATIONS:
			return{
				...state,
				errMsg: ''
			};
		case CHANGE_NOTIFICATIONS_FIELD:
			if (action.payload.key === 'selectedView') {
				let totalDisplayBoxes = Math.ceil(state.notifications.length / parseInt(action.payload.value));
				return {
					...state,
					selectedView: action.payload.value,
					totalBoxes: totalDisplayBoxes,
					value: '',
					page: 1
				}
			}
			return {
				...state,
				[action.payload.key]: action.payload.value
			};
		case NOTIFICATIONS_PAGE_SHIFT:
			if (action.payload.direction === 'left' && state.page > 1)
				return {
					...state,
					page: state.page - 1,
					totalBoxes: action.payload.totalPaginationBoxes
				};
			else if (action.payload.direction === 'right' && state.page < state.totalBoxes)
				return {
					...state,
					page: state.page + 1,
					totalBoxes: action.payload.totalPaginationBoxes
				};
			else return {
					...state,
					totalBoxes: action.payload.totalPaginationBoxes
				};
		case CHANGE_NOTIFICATIONS_CASE_TYPE_FILTER:
			let filteredNotifications = state.allNotifications;
			if(state.selectedStatus === ''){
				if(action.payload.target.value !== ''){
					filteredNotifications = filteredNotifications
						.filter(notification => notification.caseTypeId === parseInt(action.payload.target.value));
				}
			}else{
				if(action.payload.target.value === ''){
					filteredNotifications = filteredNotifications
						.filter(notification => notification.statusId === parseInt(state.selectedStatus));
				}else{
					filteredNotifications = filteredNotifications
						.filter(notification =>
						notification.statusId === parseInt(state.selectedStatus) &&
						notification.caseTypeId === parseInt(action.payload.target.value));
				}
			}
			return {
				...state,
				notifications: filteredNotifications,
				selectedCaseType: action.payload.target.value
			};
		case CHANGE_NOTIFICATIONS_STATUS_FILTER:
			let reFilteredNotifications = state.allNotifications;
			if(state.selectedCaseType === ''){
				if(action.payload.target.value !== ''){
					reFilteredNotifications = reFilteredNotifications
						.filter(notification => notification.statusId === parseInt(action.payload.target.value));
				}
			}else{
				if(action.payload.target.value === ''){
					reFilteredNotifications = reFilteredNotifications
						.filter(notification => notification.caseTypeId === parseInt(state.selectedCaseType));
				}else{
					reFilteredNotifications = reFilteredNotifications
						.filter(notification =>
						notification.caseTypeId === parseInt(state.selectedCaseType) &&
						notification.statusId === parseInt(action.payload.target.value));
				}
			}
			return {
				...state,
				notifications: reFilteredNotifications,
				selectedStatus: action.payload.target.value
			};
		case LOGOUT:
			return {
				...defaultState
			};
		default:
			return {
				...state
			}
	}
}